import React, { useEffect, useState } from 'react';
import { DashboardLibraryTabType, DashboardLibraryTabTypes } from './constants';
import { DashboardLibraryTabs } from './tabs';
import { FilterBar, FilterSpec } from 'src/common/components/filter-bar';
import { DashboardLibrarySyncedSteps } from './synced-steps';
import { DashboardLibraryOrganizationTemplates } from './organization-templates';
import useDashboardActiveTab from '../helpers/active-tab.hook';
import { DashboardLibraryContent } from './content';
import { apiGetAllOrganizationTags } from 'src/utils/journeyApi';
import { useCurrentTags } from 'src/store/tags';
import { useCurrentOrganization } from 'src/store/organization';
import { Tag } from 'src/common/interfaces/tag.interface';
import { useFilterBarParams } from 'src/common/components/filter-bar/use-params';

type DashboardLibraryPropsInterface = {
  activeListType: DashboardLibraryTabType;
};

const getFilterbarPlaceholderText = (activeListType: DashboardLibraryTabType) => {
  switch (activeListType) {
    case 'content':
      return 'Search your Library';
    case 'synced-steps':
      return 'Search synced steps';
    case 'organization-templates':
      return 'Search templates';
    default:
      return 'Search';
  }
};

export const DashboardLibrary = ({ activeListType }: DashboardLibraryPropsInterface) => {
  useDashboardActiveTab('library');

  const [activeTab, setActiveTab] = useState<DashboardLibraryTabType>(
    DashboardLibraryTabTypes.includes(activeListType) ? activeListType : DashboardLibraryTabTypes[0]
  );

  const [filterSpecList, setFilterSpecList] = useState<FilterSpec[]>([]);
  const { currentOrganization } = useCurrentOrganization();
  const { currentTags, setCurrentTags } = useCurrentTags();

  const fetchTags = async () => {
    const tagsResponse = await apiGetAllOrganizationTags(currentOrganization.id);
    setCurrentTags(tagsResponse.tags);
  };

  useEffect(() => {
    fetchTags();
  }, []);

  useEffect(() => {
    const formattedTags = currentTags.map((item: Tag) => ({
      value: String(item.id),
      label: item.name,
    }));
    setFilterSpecList([
      {
        id: 'tag_ids',
        label: 'Tags',
        type: 'multi-select',
        searchable: true,
        searchPlaceholder: 'Search for filter',
        options: formattedTags,
      },
    ]);
  }, [currentTags]);

  const {
    filterBarParams: { filters },
  } = useFilterBarParams();

  const renderContent = () => {
    if (activeTab === 'synced-steps') {
      return <DashboardLibrarySyncedSteps />;
    }

    if (activeTab === 'organization-templates') {
      return <DashboardLibraryOrganizationTemplates />;
    }

    if (activeTab === 'content') {
      return <DashboardLibraryContent />;
    }

    return null;
  };

  return (
    <>
      <div className='flex flex-col w-full'>
        <div className='text-bedrock-serif-h1'>Library</div>
        <div className='mt-6 flex w-full space-x-md'>
          <DashboardLibraryTabs activeTab={activeTab} onChangeTab={setActiveTab} />
          <FilterBar
            searchPlaceholder={getFilterbarPlaceholderText(activeListType)}
            widthClassname='w-[150px]'
            filterSpecList={filterSpecList}
          />
        </div>
        {/* <div className='grow flex flex-col mt-6'>
          {activeTab === 'synced-steps' ? (
            <DashboardLibrarySyncedSteps />
          ) : activeTab === 'organization-templates' ? (
            <DashboardLibraryOrganizationTemplates />
          ) : activeTab === 'content' ? (
            <DashboardLibraryContent />
          ) : null}
        </div> */}
        <div className='grow flex flex-col mt-6'>{renderContent()}</div>
      </div>
    </>
  );
};
